import React from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import NavBar from "../components/NavBar";

import AsteroidPage from "../games/AsteroidPage";

const Root = () => (
  <BrowserRouter>
    <NavBar />
    <Switch>
      <Route path="/asteroid" component={AsteroidPage} />
      <Redirect path="*" to="/walk" />
    </Switch>
  </BrowserRouter>
);

export default Root;
